export const IS_BROWSER = typeof window !== undefined;

export const PAGINATION_START = 8;
export const PAGINATION_INCREMENT = 8;
